import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useDeleteService } from "@/hooks/services/use-services";
import type { Service } from "@/types/services/api-types/service-types";
import { toast } from "sonner";

interface DeleteServiceDialogProps {
  service: Service | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteServiceDialog({
  service,
  open,
  onOpenChange,
}: DeleteServiceDialogProps) {
  const deleteService = useDeleteService();

  const handleDeleteConfirm = () => {
    if (service) {
      deleteService.mutate(service.id, {
        onSuccess: () => {
          toast.success(`Service "${service.name}" deleted successfully`);
          onOpenChange(false);
        },
        onError: () => {
          toast.error(`Failed to delete service "${service.name}"`);
          onOpenChange(false);
        },
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Service</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{service?.name}"?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={deleteService.isPending}
            className="w-24"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDeleteConfirm}
            disabled={deleteService.isPending}
            className="w-24"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
